import { SummitFormattedText } from '@summit/models';
import { EboNameObjectTO } from '../../base-classes/ebo-name-object-to';
import { Company } from '../../organization/company/company';
import { RoundingMethod } from '../../shared/rounding-method.enum';
import { PlotTerminal } from '../properties/plot-terminal';
import { State } from '../state/state';

export class Terminal extends EboNameObjectTO {
  tenantID: string;
  companyId: string;
  company: Company;
  region: string;
  district: string;
  typeName: string;
  description: string;
  number: number;
  abbreviation: string;

  //Address Block -- Not complex due to State FK
  addr_Line1: string;
  addr_Line2: string;
  addr_City: string;
  addr_StateId: string;
  addr_State: State;
  addr_Country: string;
  addr_PostalCode: string;

  //Contact Info
  phoneNumber: string;
  faxNumber: string;
  ivmrEmail: string;
  ivmrRoundingMethod?: RoundingMethod;
  mmrEmail: string;

  supportLinehaul: boolean;
  supportLocal: boolean;
  hidden: boolean;
  invalid: boolean;

  //used for Motive export, needs to be moved to enum as we move to businesses
  typeCategory: string = 'Terminal / Yard';

  //Parameters

  terminalProperties: PlotTerminal[];

  constructor(jsonData?: Partial<Terminal>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.company) {
        this.company = new Company(jsonData.company);
      }
      if (jsonData.addr_State) {
        this.addr_State = new State(jsonData.addr_State);
      }
      if (jsonData.terminalProperties) {
        this.terminalProperties = jsonData.terminalProperties.map((x: PlotTerminal) => new PlotTerminal(x));
      }
    }
    this.supportLinehaul ??= true;
    this.supportLocal ??= true;
    this.hidden ??= false;
    this.invalid ??= false;
  }

  private _displayName: string;
  get displayName(): string {
    if (!this._displayName) {
      if (this.number && this.name && this.number.toString() !== this.name)
        this._displayName = `${this.number} - ${this.name}`;
      else this._displayName = this.name ?? this.number?.toString() ?? '';
      if (this.abbreviation) this._displayName += ` (${this.abbreviation})`;
      this._displayName = this._displayName.trim();
      if (this._displayName.length === 0) this._displayName = 'New Terminal';
    }
    return this._displayName;
  }
  set displayName(value: string) {
    //nop
  }

  get companyAbbr(): string {
    return this.company?.abbreviation;
  }
  set companyAbbr(value: string) {
    //nop
  }

  get addressFormatted(): SummitFormattedText {
    const response = new SummitFormattedText();
    if (this.addr_Line1) response.AddLine(this.addr_Line1);
    if (this.addr_Line2) response.AddLine(this.addr_Line2);
    let cityLine = this.addr_City;
    if (this.addr_State) cityLine += ', ' + this.addr_State.abbreviation;
    if (this.addr_PostalCode) cityLine += ' ' + this.addr_PostalCode;
    cityLine = cityLine.trim();
    response.AddLine(cityLine);
    return response;
  }

  get addressString(): string {
    return this.addressFormatted.lines.join(', ');
  }

  get latitude(): number | undefined {
    var points = this.terminalProperties
      ?.filter((tp) => tp.property?.centroid != null)
      .map((tp) => tp.property.centroid);
    if (!points || points.length === 0) return undefined;
    return points[0]?.latitude;
  }

  get longitude(): number | undefined {
    var points = this.terminalProperties
      ?.filter((tp) => tp.property?.centroid != null)
      .map((tp) => tp.property.centroid);
    if (!points || points.length === 0) return undefined;
    return points[0]?.longitude;
  }

  get radiusMeters(): number | undefined {
    var radius = this.terminalProperties?.filter((tp) => tp.property?.centroid != null).map((tp) => tp.property.radius);
    if (!radius || radius.length === 0) return undefined;
    return radius[0];
  }

  get emptyString(): string | undefined {
    return undefined;
  }

  toShortString(): string {
    return this.displayName;
  }
}
